import { Button, useNotify, useRefresh } from "react-admin";
import DescriptionIcon from "@mui/icons-material/Description";
import ConfirmModal from "server/components/Modals/ConfirmModal";
import dataProvider from "server/dataProvider";
import { specialistRequests } from "api/specialistApi";

const GenerateReferralDialog = ({ id, periodId }) => {
  const notify = useNotify();
  const refresh = useRefresh();

  const handleSubmit = async () => {
    await dataProvider.customRequest(
      specialistRequests.generateAdvancedSpecializationSpecialistPeriodReferral(id, periodId),
      null,
      "POST",
    );
    notify("Направлението е генерирано успешно", { type: "success" });
    refresh();
  };

  return (
    <ConfirmModal
      onConfirm={handleSubmit}
      titleContent="Генериране на направление"
      saveTitle="Генерирай"
      message="Сигурни ли сте, че искате да генерирате направление за този период?"
      triggerButton={
        <Button
          label="Генерирай направление"
          variant="outlined"
          startIcon={<DescriptionIcon />}
        />
      }
    />
  );
};

export default GenerateReferralDialog;
